/*
 * Copyright (c) Dito Technologies
 */

import React from "react"

const ErrorSection: React.FC = () => {
    return (
        <div>
            TODO: Error Section
        </div>
    )
}

export default ErrorSection
